import { BaseService } from './BaseService';

export interface SaveNewsResponse {
    isSuccess: boolean;
}

export interface News {
    id?: string;
    title: string;
    content: string;
}

export interface NewsResponse extends News {
    id: string;
    createdAt: Date;
    flags: {
        edited: boolean;
    }
}

export class NewsService extends BaseService {
    save = async (news: News, accessToken: string): Promise<SaveNewsResponse> => {
        return await this.getResponseAsync<SaveNewsResponse>(
            {
                commandPath: `news`,
                method: 'POST',
                body: news,
            },
            accessToken,
        );
    };

    update = async (news: News, accessToken: string): Promise<SaveNewsResponse> => {
        return await this.getResponseAsync<SaveNewsResponse>(
            {
                commandPath: `news`,
                method: 'PATCH',
                body: news,
            },
            accessToken,
        );
    };

    load = async (accessToken: string): Promise<NewsResponse[]> => {
        return await this.getResponseAsync<NewsResponse[]>(
            {
                commandPath: `news`,
                method: 'GET',
            },
            accessToken,
        );
    };

    delete = async (newsId: string, accessToken: string): Promise<void> => {
        await this.getResponseAsync(
            {
                commandPath: `news/${newsId}`,
                method: 'DELETE',
            },
            accessToken,
        );
    };
}
